module.exports = __webpack_public_path__ + "img/ics_o_chevron_sort_asc.85f2633c.svg";